export * from './mobile-content-block';
